import React from 'react';
import { IIconProps, IconHeight, IconWidth, IconSizes } from './type';

const Information: React.FC<IIconProps> = ({
  size = IconSizes.sm,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        d="M22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12Z"
        fill="#B0C5F1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21.3C17.1362 21.3 21.3 17.1362 21.3 12C21.3 6.86375 17.1362 2.7 12 2.7C6.86375 2.7 2.7 6.86375 2.7 12C2.7 17.1362 6.86375 21.3 12 21.3ZM12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z"
        fill="black"
      />
      <path
        d="M12.9141 7.42969C12.9141 7.93451 12.5048 8.34375 12 8.34375C11.4952 8.34375 11.0859 7.93451 11.0859 7.42969C11.0859 6.92486 11.4952 6.51562 12 6.51562C12.5048 6.51562 12.9141 6.92486 12.9141 7.42969Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1141 7.42969C14.1141 8.59725 13.1676 9.54375 12 9.54375C10.8324 9.54375 9.88594 8.59725 9.88594 7.42969C9.88594 6.26212 10.8324 5.31563 12 5.31563C13.1676 5.31563 14.1141 6.26212 14.1141 7.42969ZM12 8.34375C12.5048 8.34375 12.9141 7.93451 12.9141 7.42969C12.9141 6.92486 12.5048 6.51562 12 6.51562C11.4952 6.51562 11.0859 6.92486 11.0859 7.42969C11.0859 7.93451 11.4952 8.34375 12 8.34375Z"
        fill="black"
      />
      <path
        d="M11.0859 12.3141C11.0859 11.8092 11.4952 11.4 12 11.4C12.5048 11.4 12.9141 11.8092 12.9141 12.3141V16.4859C12.9141 16.9908 12.5048 17.4 12 17.4C11.4952 17.4 11.0859 16.9908 11.0859 16.4859V12.3141Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1141 12.3141V16.4859C14.1141 17.6535 13.1676 18.6 12 18.6C10.8324 18.6 9.88594 17.6535 9.88594 16.4859V12.3141C9.88594 11.1465 10.8324 10.2 12 10.2C13.1676 10.2 14.1141 11.1465 14.1141 12.3141ZM12 11.4C11.4952 11.4 11.0859 11.8092 11.0859 12.3141V16.4859C11.0859 16.9908 11.4952 17.4 12 17.4C12.5048 17.4 12.9141 16.9908 12.9141 16.4859V12.3141C12.9141 11.8092 12.5048 11.4 12 11.4Z"
        fill="black"
      />
    </svg>
  );
};

export default Information;
